import sendWebSocketMessage from './sendWebSocketMessage';
import { MessageType } from '../../constants/websocketMessageTypes';

// Not using export default because this page is gonna contain a collection of
// constasts/functions that will push to websocket
export const incrementUIRequestsCounter = () => {
  // alert('Increment');
  const message = JSON.stringify({
    type: MessageType.INCREMENT_UI_REQUEST,
  });
  sendWebSocketMessage(message);
};
